import { Button, makeStyles, Tooltip } from '@material-ui/core';
import { IconCalendarStar } from '@tabler/icons-react';
import classNames from 'classnames';
import { isValid, differenceInDays, intlFormatDistance } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import React from 'react';

import {
  startOfDayInBoulderTimezone,
  startOfTodayInBoulderTimezone,
} from 'src/businessHours/timezone';
import { useButtonStyles } from 'src/patientHeader/components/badges/styles/useButtonStyles';
import { useTooltipStyles } from 'src/patientHeader/components/badges/styles/useTooltipStyles';
import { theme as appTheme } from 'src/theme';

const localZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const PicEligibilityDate: React.FC<{
  patientId: string;
  picEligibilityDateOnly: string | null;
}> = ({ patientId, picEligibilityDateOnly }) => {
  const tooltipStyles = useTooltipStyles();
  const buttonStyles = useButtonStyles();
  const styles = useStyles();

  if (!picEligibilityDateOnly) return null;

  const picEligibilityDate = startOfDayInBoulderTimezone(picEligibilityDateOnly);
  if (!isValid(picEligibilityDate)) return null;

  const today = startOfTodayInBoulderTimezone();

  const daysUntilEligibility = differenceInDays(picEligibilityDate, today);
  const buttonClassNames = [buttonStyles.button];

  const timeDistance =
    Math.abs(daysUntilEligibility) >= 1
      ? intlFormatDistance(picEligibilityDate, today, { unit: 'day' })
      : 'today';

  return (
    <Tooltip
      title={`PIC eligibility day: ${timeDistance}`}
      placement="right"
      enterDelay={300}
      enterNextDelay={300}
      leaveTouchDelay={300}
      classes={{
        tooltip: tooltipStyles.tooltip,
      }}
    >
      <a href={`/patients/${patientId}/overview#picEligibility`}>
        <Button
          classes={{ startIcon: styles.startIcon }}
          className={classNames(buttonClassNames)}
          fullWidth
          size="small"
          startIcon={<IconCalendarStar size={appTheme.typography.fontSize} />}
          variant="outlined"
        >
          {formatInTimeZone(picEligibilityDate, localZone, 'MM/dd/yyyy')}
        </Button>
      </a>
    </Tooltip>
  );
};

const useStyles = makeStyles({
  startIcon: {
    marginRight: 4,
  },
});
